<template>
  <div class="StatusWaveDetail">
    <div class="swd-meta-data" v-if="statusData && statusData.Wave">
      <h4><b>{{ statusData.Wave.WaveName }}</b></h4>
      <span>{{ globals.toLocaleDateString(statusData.Wave.WaveSince) }} - {{ globals.toLocaleDateString(statusData.Wave.WaveUntil) }}</span>
    </div>
    <div style="width: 100%">
      <div style="width: 20%; margin-left: 12px;">
        <select2
          class="form-control"
          v-model="selectedApprovalStatus"
          ref="approvalStatusSelect"
          :placeholder="lang.AWS036"
          :allowClear="true"
          @change="getWaveStatus()"
        >
          <option value="approved">Approved</option>
          <option value="none">None</option>
          <option value="open">Open</option>
        </select2>
      </div>
    </div>

    <div class="swd-two-col">
      <!-- Check Status -->
      <div v-if="statusData && statusData.SurveyInstances" class="stat-container">
        <b class="stat-container-title">{{ lang.AWS005 }}</b>
        <div class="stat-row">
          <StatIndicator
            :value="statusData.SurveyInstances.Status.Count"
            :label="lang.AWS006"
            :centerText="statusData.SurveyInstances.Status.Count"
            :showRing="false"
            :showSquare="true"
          />
          <StatIndicator
            :value="statusData.SurveyInstances.Status.Approval"
            :label="lang.AWS007"
            :centerText="statusData.SurveyInstances.Status.Approval"
            :showRing="false"
            :showSquare="true"
          />
          <StatIndicator
            :value="statusData.SurveyInstances.Status.InProgress"
            :label="lang.AWS008"
            :centerText="statusData.SurveyInstances.Status.InProgress"
            :showRing="false"
            :showSquare="true"
          />
          <StatIndicator
            :value="statusData.SurveyInstances.Status.Reporting"
            :label="lang.AWS009"
            :centerText="statusData.SurveyInstances.Status.Reporting"
            :showRing="false"
            :showSquare="true"
          />
          <StatIndicator
            :value="statusData.Wave.InTime"
            :label="lang.AWS010"
            :centerText="statusData.Wave.InTime"
            :isPercentage="true"
            suffix="%"
          />  
        </div>
      </div>
      <!-- Approvals -->
      <div v-if="statusData && statusData.Approvals" class="stat-container">
        <b class="stat-container-title">{{ lang.AWS011 }}</b>
        <div class="stat-row">
          <StatIndicator
            :value="statusData.Approvals.None"
            :label="lang.AWS012"
            :centerText="statusData.Approvals.None"
            :isPercentage="true"
            suffix="%"
          />
          <StatIndicator
            :value="statusData.Approvals.Open"
            :label="lang.AWS013"
            :centerText="statusData.Approvals.Open"
            :isPercentage="true"
            suffix="%"
          />
          <StatIndicator
            :value="statusData.Approvals.Approved"
            :label="lang.AWS014"
            :centerText="statusData.Approvals.Approved"
            :isPercentage="true"
            suffix="%"
          />  
        </div>
      </div>
    </div>

    <div v-if="statusData && statusData.Shopper" class="stat-container">
      <b class="stat-container-title">{{ lang.AWS015 }}</b>
      <div class="stat-row">
        <!-- gender -->
        <div class="special-stat-container" v-if="statusData.Shopper.Gender">
          <b>{{ lang.AWS016 }}</b>
          <div style="display: flex; flex-direction: row;">
            <StatIndicator
              :value="statusData.Shopper.Gender.Male"
              :label="lang.AWS017"
              :centerText="statusData.Shopper.Gender.Male"
              :isPercentage="true"
              suffix="%"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Gender.Female"
              :label="lang.AWS018"
              :centerText="statusData.Shopper.Gender.Female"
              :isPercentage="true"
              suffix="%"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Gender.Divers"
              :label="'Divers'"
              :centerText="statusData.Shopper.Gender.Divers"
              :isPercentage="true"
              suffix="%"
            /> 
          </div>
        </div>
        <!-- age -->
        <div class="special-stat-container" v-if="statusData.Shopper.Age">
          <b>{{ lang.AWS019 }}</b>
          <div style="display: flex; flex-direction: row;">
            <StatIndicator
              :value="statusData.Shopper.Age.Min"
              :label="lang.AWS020"
              :centerText="statusData.Shopper.Age.Min"
              :showRing="false"
              :showSquare="true"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Age.Max"
              :label="lang.AWS021"
              :centerText="statusData.Shopper.Age.Max"
              :showRing="false"
              :showSquare="true"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Age.Above70"
              :label="lang.AWS022"
              :centerText="statusData.Shopper.Age.Above70"
              :isPercentage="true"
              suffix="%"
            /> 
            
          </div>
        </div>
        <!-- distance -->
        <div class="special-stat-container" v-if="statusData.Shopper.Distance">
          <b>{{ lang.AWS023 }}</b>
          <div style="display: flex; flex-direction: row;">
            <StatIndicator
              :value="statusData.Shopper.Distance.Min / 1000"
              :label="lang.AWS020"
              :centerText="statusData.Shopper.Distance.Min / 1000"
              :showRing="false"
              :showSquare="true"
              :decimalPlaces="0"
              suffix=" km"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Distance.Max / 1000"
              :label="lang.AWS021"
              :centerText="statusData.Shopper.Distance.Max / 1000"
              :showRing="false"
              :showSquare="true"
              :decimalPlaces="0"
              suffix=" km"
            /> 
          </div>
        </div>
        <!-- car -->
        <div class="special-stat-container" v-if="statusData.Shopper.Car">
          <b>{{ lang.AWS024 }}</b>
          <div style="display: flex; flex-direction: row;">
            <StatIndicator
              :value="statusData.Shopper.Car.YearOfBuild.Min"
              :label="lang.AWS020"
              :centerText="statusData.Shopper.Car.YearOfBuild.Min"
              :showRing="false"
              :showSquare="true"
            /> 
            <StatIndicator
              :value="statusData.Shopper.Car.YearOfBuild.Max"
              :label="lang.AWS021"
              :centerText="statusData.Shopper.Car.YearOfBuild.Max"
              :showRing="false"
              :showSquare="true"
            /> 
          </div>
        </div>
        <!-- model -->
        <div class="special-stat-container" v-if="statusData.Model">
          <b>{{ lang.AWS025 }}</b>
          <div style="display: flex; flex-direction: row;">
            <StatIndicator
              :value="statusData.Model.Downgrade"
              :label="lang.AWS026"
              :centerText="statusData.Model.Downgrade"
              :isPercentage="true"
              suffix="%"
            /> 
            <StatIndicator
              :value="statusData.Model.Match"
              :label="lang.AWS027"
              :centerText="statusData.Model.Match"
              :isPercentage="true"
              suffix="%"
            /> 
            <StatIndicator
              :value="statusData.Model.Upgrade"
              :label="lang.AWS028"
              :centerText="statusData.Model.Upgrade"
              :isPercentage="true"
              suffix="%"
            /> 
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="statusData && statusData.CarDistribution" class="stat-container">
      <b class="stat-container-title">{{ lang.AWS037 }}</b>
      <table class="car-distribution-table">
        <thead>
          <tr>
            <th>{{ lang.WV0044 }}</th>
            <th>{{ lang.AWS030 }}</th>
            <th>{{ lang.AWS031 }}</th>
            <th style="text-align: center;">{{ lang.AWS032 }}</th>
            <th style="text-align: center;">{{ lang.AWS026 }}</th>
            <th style="text-align: center;">{{ lang.AWS028 }}</th>
            <th style="text-align: center;">{{ lang.AWS027 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(model, index) in statusData.CarDistribution" :key="index">
            <td>Audi</td>
            <td>{{ model.CarModelName }}</td>
            <td>
              <StatIndicator
                :value="model.SetValue"
                :centerText="model.SetValue"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ActualValue"
                :centerText="model.ActualValue"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountDowngrade_percentage"
                :centerText="model.ApprovedCarCountDowngrade_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountMatch_percentage"
                :centerText="model.ApprovedCarCountMatch_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountUpgrade_percentage"
                :centerText="model.ApprovedCarCountUpgrade_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
          </tr>
          <tr v-for="(model, index) in statusData.CompetitorCarDistribution" :key="index">
            <td>{{ model.CompetitorCarBrand }}</td>
            <td>{{ model.CompetitorCarModel }}</td>
            <td>
              <StatIndicator
                :value="model.SetValue"
                :centerText="model.SetValue"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ActualValue"
                :centerText="model.ActualValue"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountDowngrade_percentage"
                :centerText="model.ApprovedCarCountDowngrade_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountMatch_percentage"
                :centerText="model.ApprovedCarCountMatch_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
            <td>
              <StatIndicator
                :value="model.ApprovedCarCountUpgrade_percentage"
                :centerText="model.ApprovedCarCountUpgrade_percentage"
                :isPercentage="true"
                suffix="%"
              /> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import StatIndicator from '../Tools/StatIndicator.vue';
import Select2 from "../Tools/Select2";

export default {
  name: 'StatusWaveDetail',
  components: { StatIndicator, Select2 },
  props: {
    waveGuid: null
  },
  data() {
    return {
      statusData: null,
      selectedApprovalStatus: null,
      lang: {
        AWS000: "Wave Status",
        AWS001: "Project",
        AWS002: "Wave",
        AWS003: "Please select a project...",
        AWS004: "Please select a wave...",
        AWS005: "Check Status",
        AWS006: "Total check count",
        AWS007: "In approval",
        AWS008: "In progress",
        AWS009: "In reporting",
        AWS010: "In time",
        AWS011: "Approvals",
        AWS012: "None",
        AWS013: "Open",
        AWS014: "Approved",
        AWS015: "Wave charactertistics",
        AWS016: "Gender",
        AWS017: "Male",
        AWS018: "Female",
        AWS019: "Age",
        AWS020: "Min",
        AWS021: "Max",
        AWS022: "Above 70",
        AWS023: "Distance",
        AWS024: "Reg. year shopper car",
        AWS025: "Model match",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",
        AWS034: "Close",
        AWS035: "Wave status access failed",
        AWS036: "Please select a approval status...",
        AWS037: "Cars",
        
        WV0044: "Brand",
      }
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.getWaveStatus();
  },
  methods: {
    getWaveStatus() {
      let query = `api/ProjectWaves/${this.waveGuid}/AgencyStatus`;
      if (this.selectedApprovalStatus)
        query += `?ApprovalStatus=${this.selectedApprovalStatus}`;
      else query += "?ApprovalStatus=all";

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) this.statusData = data;
        },
        error: (error) => {
          console.error("Error on GET in getWaveStatus()", error);
          this.globals.showErrorSnackbar(this.lang.AWS035);
        },
      });
    },
    getGroupedCompetitorCars() {
      if (!this.statusData.CompetitorCarDistribution) {
        return [];
      }

      let carBrandMap = new Map();
      for (let ccd of this.statusData.CompetitorCarDistribution) {
        if (!carBrandMap.has(ccd.CompetitorCarBrand)) {
          carBrandMap.set(ccd.CompetitorCarBrand, []);
        }
        carBrandMap.get(ccd.CompetitorCarBrand).push(ccd);
      }
      return Array.from(carBrandMap);
    }
  }
};
</script>

<style scoped>
.StatusWaveDetail {
  display: flex;
  flex-direction: column;
  padding: 0px 50px;
  row-gap: 10px;
  overflow: auto;
  height: calc(100% - 44px);
}
.StatusWaveDetail>div:last-child {
  margin-bottom: 20px;
}
.swd-meta-data {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  width: 33%;
  margin-left: 12px;
}
.stat-container {
  border: 1px solid lightgray;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  transition: all .2s;
}
.stat-container:hover {
  border: 1px solid var(--color-primary);
  box-shadow: 0px 5px 5px rgb(206, 206, 206);
  transform: translateY(-2px);
}
.stat-container-title {
  padding-bottom: 10px;
}
.stat-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.swd-two-col {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.swd-two-col .stat-container {
  width: 48%;
}
.special-stat-container {
  display: flex;
  flex-direction: column;
}
.special-stat-container b {
  margin-bottom: 10px;
}
.car-distribution-table {
  width: 100%;
  text-align: left;
}
.car-distribution-table thead tr {
  border-bottom: 1px solid lightgray;
}
.car-distribution-table thead tr th {
  padding-bottom: 8px;
}
.car-distribution-table tbody tr {
  border-bottom: 1px solid lightgray;
}
.car-distribution-table tbody tr td {
  padding: 6px 0px;
}
.car-distribution-table tbody tr:hover {
  background-color: rgb(245, 245, 245) !important;
}
.car-distribution-table tbody tr:nth-child(odd) {
  background-color: rgb(250, 250, 250);
}
</style>


// WEBPACK FOOTER //
// StatusWaveDetail.vue?6aef0637